import styled from "styled-components";

export const UCPPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  gap: 24px;
`;

export const ContainerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  height: 100%;
`;

// Wrapper that keeps ChatSlideOut in the DOM after first open (mount-once pattern).
// Width collapses to 0 when closed so it doesn't affect the flex layout,
// avoiding the Chrome mount/unmount overhead on every open/close.
export const UCPChatWrapper = styled.div`
  overflow: hidden;
  flex-shrink: 0;
  width: ${({ $isOpen }) => ($isOpen ? 'auto' : '0')};
`;